export type FormatDateValue = Date | number;

function numberLocale(locale: string): string {
  const [base, extension] = locale.split('-u-', 2);
  const language = base.split('-', 1)[0]?.toLowerCase();
  if (language !== 'ar' || extension?.includes('nu-')) return locale;
  return extension
    ? `${base}-u-${extension}-nu-arab`
    : `${base}-u-nu-arab`;
}

export function fmtDate(
  value: FormatDateValue,
  locale: string,
  options: Intl.DateTimeFormatOptions = { dateStyle: 'medium' },
): string {
  return new Intl.DateTimeFormat(locale, options).format(value);
}

export function fmtTime(
  value: FormatDateValue,
  locale: string,
  options: Intl.DateTimeFormatOptions = { timeStyle: 'short' },
): string {
  return new Intl.DateTimeFormat(locale, options).format(value);
}

export function fmtDateTime(
  value: FormatDateValue,
  locale: string,
  options: Intl.DateTimeFormatOptions = { dateStyle: 'medium', timeStyle: 'short' },
): string {
  return new Intl.DateTimeFormat(locale, options).format(value);
}

export function fmtNumber(
  value: number,
  locale: string,
  options?: Intl.NumberFormatOptions,
): string {
  // Manche Laufzeiten waehlen fuer `ar` lateinische Ziffern samt US-Komma.
  // Der explizite arabische Nummerierungsmodus haelt Web, WebView und Tests
  // konsistent, ohne Aufrufer mit Locale-Details zu belasten.
  return new Intl.NumberFormat(numberLocale(locale), { maximumFractionDigits: 2, ...options }).format(value);
}

export function fmtCurrency(
  value: number,
  currency: string,
  locale: string,
  options?: Omit<Intl.NumberFormatOptions, 'currency' | 'style'>,
): string {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 2, ...options, style: 'currency', currency }).format(value);
}
